import { GetDevBoxHyperVResponse } from '../../../data/services/data-plane-api/add-ons';
import { DevBoxHyperVAddOn } from '../../../models/add-ons';
import { createActionCreator } from '../core-action-creators';
import { ErrorPayload, IndexedPayload, PollPayload, ResultPayload } from '../core-actions';
import {
    AddDevBoxHyperVAcceptedPayload,
    AddDevBoxHyperVErrorPayload,
    AddDevBoxHyperVFailedPayload,
    AddDevBoxHyperVPayload,
    DevBoxHyperVActionType,
    PollNonTerminalDevBoxHyperVCompletePayload,
} from './hyper-v-actions';

/**
 * Action creators
 */

export const addDevBoxHyperV = createActionCreator<AddDevBoxHyperVPayload>(DevBoxHyperVActionType.AddDevBoxHyperV, {
    startsActivity: true,
});
export const addDevBoxHyperVAccepted = createActionCreator<AddDevBoxHyperVAcceptedPayload>(
    DevBoxHyperVActionType.AddDevBoxHyperVAccepted
);
export const addDevBoxHyperVError = createActionCreator<AddDevBoxHyperVErrorPayload>(
    DevBoxHyperVActionType.AddDevBoxHyperVError
);
export const addDevBoxHyperVFailed = createActionCreator<AddDevBoxHyperVFailedPayload>(
    DevBoxHyperVActionType.AddDevBoxHyperVFailed
);

export const addDevBoxHyperVSuccess = createActionCreator<ResultPayload<DevBoxHyperVAddOn>>(
    DevBoxHyperVActionType.AddDevBoxHyperVSuccess
);

export const pollNonTerminalDevBoxHyperV = createActionCreator<
    IndexedPayload & PollPayload & { name: string },
    GetDevBoxHyperVResponse
>(DevBoxHyperVActionType.PollNonTerminalDevBoxHyperV, { async: true, startsActivity: true });

export const pollNonTerminalDevBoxHyperVComplete = createActionCreator<PollNonTerminalDevBoxHyperVCompletePayload>(
    DevBoxHyperVActionType.PollNonTerminalDevBoxHyperVComplete
);

export const pollNonTerminalDevBoxHyperVError = createActionCreator<ErrorPayload & IndexedPayload>(
    DevBoxHyperVActionType.PollNonTerminalDevBoxHyperVError
);
